import { render, staticRenderFns } from "./AdminDepositBankAccountIndexPageTableRow.vue?vue&type=template&id=072b783a&"
import script from "./AdminDepositBankAccountIndexPageTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminDepositBankAccountIndexPageTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports